export default {
  showDeclinedCheckbox: 'show-declined-checkbox',
  b2bDeclineBtn: 'btn-decline-b2b-response',
  serviceDeclineBtn: 'btn-decline-service-response',
  // [MCV-1858] B2B platform-fee schedule shown in the accept dialog.
  feeScheduleSection: 'b2b-fee-schedule',
  feeAuthorizationCheckbox: 'b2b-fee-authorization-checkbox',
  feeScheduleChangedNotice: 'b2b-fee-schedule-changed-notice',
  // [MCV-1933] Commitment credit line and the promotional-credit disclosure under the schedule.
  feeCommitmentCredit: 'fee-commitment-credit',
  feeCreditDisclosure: 'fee-credit-disclosure',
  // [MCV-1933] Listing-fee confirmation shown before publishing an employer listing.
  listingFeeDialog: 'listing-fee-dialog',
  listingFeeConfirmBtn: 'listing-fee-confirm-btn',
  listingFeeCancelBtn: 'listing-fee-cancel-btn',
};
